@switch (_currentLangSig()) {
  @case ('es') {
    <ng-container *ngTemplateOutlet="spanishPolicy" />
  }
  @case ('en') {
    <ng-container *ngTemplateOutlet="englishPolicy" />
  }
  @case ('pt') {
    <ng-container *ngTemplateOutlet="portuguesePolicy" />
  }
  @default {
    <ng-container *ngTemplateOutlet="spanishPolicy" />
  }
}
<ng-template #spanishPolicy>
  <h4 class="mb-2">POLÍTICA DE PRIVACIDAD PARA SERVICIOS EN ESPAÑA</h4>
  <p class="mb-2">
    ACCIONA GREEN ENERGY DEVELOPMENTS, S.L. (en adelante, ACCIONA GREEN ENERGY), conforme al Reglamento (UE) 2016/679, 27 de abril de 2016,
    relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de
    estos, y demás normativa vigente en materia de Protección de Datos; pone a disposición de todos aquellos que mediante su interacción con
    nosotros, faciliten información de carácter personal (en adelante, “Usuario”), a través de ésta página web (en adelante, la “Página”),
    la Política de Privacidad que aplicará en el tratamiento de los datos de carácter personal.
  </p>
  <p class="mb-2">
    Los datos de carácter personal sólo podrán obtenerse para su tratamiento cuando sean adecuados, pertinentes y no excesivos en relación
    con el ámbito y las finalidades determinadas, explícitas y legítimas para las que se hayan obtenido. El Usuario consiente expresamente
    que ACCIONA GREEN ENERGY pueda tratar los datos de carácter personal proporcionados por el mismo para los fines expresados en la
    presente Política de Privacidad.
  </p>
  <p class="mb-2">
    ACCIONA GREEN ENERGY adopta las medidas de índole técnica y organizativa necesarias para garantizar la seguridad de los datos de
    carácter personal contenidos en los mismos y para evitar su alteración, pérdida, tratamiento o acceso no autorizado, habida cuenta del
    estado de la tecnología, la naturaleza de los datos y los riesgos a los que están expuestos.
  </p>
  <p class="mb-2">
    También puede verificar la presencia del certificado SSL comprobando las propiedades de la Página en su navegador. Una conexión será
    segura cuando en la barra de direcciones del navegador aparece "https://" en lugar de "http://" y se muestra el símbolo de un candado.
    Puede consultar más características del certificado SSL en el apartado Aviso Legal.
  </p>
  <h5 class="mb-2"><strong>¿Quién es el responsable del tratamiento de los datos de carácter personal?</strong></h5>
  <ul>
    <li><strong>Denominación social:</strong> ACCIONA GREEN ENERGY DEVELOPMENTS, S.L.</li>
    <li><strong>CIF: </strong>B-31737422.</li>
    <li><strong>Dirección:</strong> Avenida de la Gran Vía de Hortaleza, 1, 28033, Madrid.</li>
    <li>
      <strong>Teléfono:</strong> <a href="tel:+34{{ _phoneNumber }}"> {{ _phoneNumber }}</a>
    </li>
  </ul>
  <p class="mb-2">
    El Delegado de protección de datos es un punto de contacto con la entidad responsable, para cuestiones relativas al tratamiento de datos
    personales. Si lo desea, puede contactar con él en:
    <strong
      ><a href="mailto:{{ _protectDataContactEmail }}" target="_blank" rel="noreferrer noopener">{{ _protectDataContactEmail }}</a></strong
    >
  </p>
  <h5 class="mb-2"><strong>¿Qué datos podemos recabar a través de la Página?</strong></h5>
  <p class="mb-2">Datos personales se consideran, aquellos que identifican a una persona o pueden utilizarse para identificarla.</p>
  <p class="mb-2">
    Podemos recibir los datos personales facilitados directamente por el Usuario, a través de su visita a la Página y cuando se registra en
    nuestro servicio o, cuando el Usuario contacta con el Centro de Atención al Usuario (CAU) o Servicio de Atención al Cliente (SAC), ya
    sea por correo electrónico o por teléfono (las llamadas se graban y se le advierte de esto con carácter previo, para que no continúe si
    no quiere ser grabado).
  </p>
  <p class="mb-2">
    También, como consecuencia de su interacción con nosotros, podemos recibir sus datos personales al cumplimentar formularios o encuestas,
    cuando nos solicita información, envía peticiones, comunica incidencias, etc. En otros casos, los datos de carácter personal se obtienen
    de manera <u>indirecta</u> del usuario para poder analizar el uso que realiza de nuestra Página (Consulte nuestra
    <a [routerLink]="_cookiesRoute">Política de Cookies</a> o facilitarle entre otros servicios de valor añadido.
  </p>

  <h5 class="mb-2"><strong>Entre las categorías de datos que podemos tratar están:</strong></h5>
  <ul class="space-y-2 mb-2 ml-5">
    <li>
      Datos identificativos y de contacto: nombre y apellidos, DNI o documento identificativo válido, domicilio, país de residencia, número
      de teléfono, correo electrónico, dirección IP.
    </li>
    <li>Datos financieros o relativos al servicio prestado: datos de facturación.</li>
  </ul>
  <p class="mb-2">
    El Usuario es el único responsable de la veracidad y licitud de los datos personales facilitados, y asume la obligación de comunicar
    cualquier cambio en ellos a ACCIONA cuando los que esta tiene devengan inexactos o incorrectos.
  </p>

  <h5 class="mb-2"><strong>¿Con qué finalidad y legitimación tratamos los datos de carácter personal del Usuario?</strong></h5>
  <p class="mb-2">ACCIONA GREEN ENERGY recoge y trata los datos de carácter personal de los Usuarios, con las siguientes finalidades:</p>

  <ul class="space-y-2 mb-2 ml-5">
    <li>
      <strong>Gestionar la relación establecida con nosotros</strong>
      <p class="mb-2">
        Gestionar el contrato de suministro de energía, gestionar la facturación, facilitarle el acceso a todos los documentos relacionados
        de su contrato. <br />
        Atender sus consultas y peticiones a través de los cuestionarios disponibles. <br />
        Tramitación de las reclamaciones, quejas y sugerencias. <br />
        En estos casos, la base jurídica del tratamiento es el consentimiento prestado por el Usuario, así como la ejecución de un contrato
        y/o las relaciones jurídicas establecidas con ACCIONA GREEN ENERGY.
      </p>
    </li>
    <li>
      <strong>Gestión del servicio con el Usuario</strong>
      <p class="mb-2">
        Gestionar el alta como Usuario registrado, y mantenimiento de la cuenta. Administración y gestión de las cuentas de Usuarios del
        servicio. Atender y tramitar solicitudes de información, reclamaciones, quejas, sugerencias, incidencias y/o consultas recibidas a
        través Centro de atención al usuario o del Servicio de Atención al usuario. <br />
        En estos casos, la base jurídica del tratamiento es el consentimiento prestado por el Usuario, así como la ejecución de un contrato
        y/o las relaciones jurídicas establecidas.
      </p>
    </li>
    <li>
      <strong>Cumplimiento de las obligaciones legales que nos afecten.</strong>
      <p class="mb-2">
        Ya sean estas obligaciones legales de índole mercantil, fiscal, contable, administrativa. Esta finalidad del tratamiento puede
        conllevar la cesión de datos a organismos y autoridades públicas, siempre y cuando sean requeridos de conformidad con las
        disposiciones legales y reglamentarias. <br />
        En estos casos, la base legal del tratamiento es el cumplimiento de obligaciones legales del responsable.
      </p>
    </li>
    <li>
      <strong>Prevención del fraude</strong>
      <p class="mb-2">
        En ocasiones es necesario comprobar la identidad con la finalidad de ofrecer protección, detectar y prevenir fraudes u otras
        actividades ilícitas, transacciones no autorizadas, reclamaciones y otro tipo de responsabilidades, así como gestionar la calidad y
        los riesgos asociados al negocio; así como investigar en caso de ser necesario, actividades ilegales y potenciales quebrantamientos
        de nuestras políticas y/o condiciones de nuestros servicios. <br />
        La base jurídica es el cumplimiento de obligaciones legales que apliquen en cada caso.
      </p>
    </li>
    <li>
      <strong>Estadísticas y encuestas de satisfacción</strong>
      <p class="mb-2">
        Podemos tratar los datos de los Usuarios para realizar encuestas de satisfacción en relación con nuestros servicios, así como
        recoger cookies mediante la navegación en los entornos web. La base legitimadora en este caso es el consentimiento prestado por el
        Usuario.
      </p>
    </li>
    <li>
      <strong>Actividades promocionales y comunicaciones comerciales</strong>
      <ul class="space-y-2 mb-2 ml-5">
        <li>
          Ofrecerle, entre otros, el acceso a anuncios y avisos donde encontrará información relevante las noticias acerca del mercado
          eléctrico.
        </li>
        <li>
          Información sobre la gestión de la venta de la energía producida por las instalaciones del grupo, así como la de otros
          productores, a cuyo servicio pone su experiencia y capacidad técnica con garantía de origen 100% renovable.
        </li>
        <li>
          Envío de comunicaciones comerciales, así como invitaciones a eventos y actividades, por medios postales y electrónicos,
          relacionadas con los servicios y productos contratados con ACCIONA GREEN ENERGY.
        </li>
      </ul>
    </li>
    <p class="mb-2">
      En estos casos, la base jurídica del tratamiento es el consentimiento prestado por el Usuario, así como la ejecución de un contrato
      y/o las relaciones jurídicas establecidas.
    </p>

    <li>
      <strong>Comprobación de la solvencia de los Usuarios para suscribir un contrato</strong>
      <p class="mb-2">
        Cuando un Usuario quiere formalizar un contrato de suministro de energía eléctrica, ACCIONA recurre a terceras empresas para conocer
        la solvencia económica del Usuario y, en su caso, pedirle garantías adicionales, tal y como se explica en el contrato. Así, ACCIONA
        recabará datos personales del Usuario de terceros cuyo objeto social consiste en proporcionar referencias o informes comerciales y
        de solvencia financiera o crediticia, siempre que estos manifiesten su voluntad de formalizar un contrato con ACCIONA. Con tales
        datos personales de solvencia del Usuario, además del resto de información que le proporcione, ACCIONA podrá valorar la viabilidad
        del Contrato. La información obtenida de dichos terceros ACCIONA la mantendrá (a) durante el mismo tiempo que se guarden los datos
        contenidos en el Contrato (plazo que puede llegar a ser de hasta seis años desde su terminación), o (b) durante un (1) mes desde que
        el proceso de contratación termine por no resultar viable, para atender eventuales reclamaciones de aquellas personas con las que no
        se haya podido concluir un contrato. Tal información obtenida de terceros, junto el resto de información proporcionada por el
        CLIENTE, es necesaria para la correcta ejecución del contrato (pues la solvencia de ambas partes es esencial) y se recaba por
        ACCIONA no solo con base en la necesidad de que el Contrato se cumpla, sino también con base en su interés legítimo como empresa que
        suministra energía eléctrica a cambio de un precio.
      </p>
    </li>
  </ul>

  <h5 class="mb-2"><strong>¿Por cuánto tiempo conserva ACCIONA GREEN ENERGY los datos de carácter personal del Usuario?</strong></h5>
  <p class="mb-2">
    Con carácter general, los datos serán conservados i) por el tiempo que fueran necesario para la finalidad que fueron recogidos y, ii)
    durante los plazos de prescripción que le sean de aplicación, si pudieran surgir responsabilidades derivadas del tratamiento, o para
    cumplir obligaciones exigibles a ACCIONA que la obliguen a conservar tales datos (como, por ejemplo, las obligaciones de conservación de
    la información establecidas en el Código de Comercio).
  </p>
  <p class="mb-2">Con carácter particular,</p>
  <ul class="space-y-2 mb-2 ml-5">
    <li>
      Los datos recopilados con la finalidad de atender solicitudes o consultas serán conservados durante el tiempo necesario para poder
      atender las mismas.
    </li>
    <li>Los datos recopilados con base en su consentimiento serán conservados mientras no se retire el mismo.</li>
    <li>
      Los datos recopilados de terceros para evaluar la solvencia se conservarán (a) durante toda la vida del contrato que se firme con el
      Usuario, o (b) durante un mes desde que se inicie un proceso de contratación por infructuoso, para atender eventuales reclamaciones de
      la persona que no ha podido contratar con ACCIONA.
    </li>
    <p class="mb-2">
      Los datos se conservarán mientras se mantenga le relación y no se solicite su supresión y con posterioridad durante el plazo de
      prescripción legal de las acciones que les resulten de aplicación.
    </p>
  </ul>

  <h5 class="mb-2"><strong>¿A quién puede el Responsable facilitar los datos proporcionados por el Usuario?</strong></h5>
  <p class="mb-2">
    En función de la actividad de ACCIONA GREEN ENERGY están previstas las siguientes cesiones de datos, cuando sea necesario:
  </p>
  <ul class="space-y-2 mb-2 ml-5">
    <li>
      A Organismos de la Administración Pública con competencia en materia de comunicaciones y prestaciones de servicios de la información y
      Organismos con competencia en materia de consumo para atender las posibles reclamaciones de los Usuarios.
    </li>
    <li>
      A la Agencia Tributaria y demás administraciones y entidades públicas estatales, autonómicas y locales competentes, a los efectos de
      llevar a cabo las declaraciones tributarias (impuestos y tasas) correspondientes, así como a entidades financieras, bancarias y de
      crédito, para la gestión económica de operaciones mercantiles y financieras y a pasarelas de pago y/o aseguradoras para la gestión de
      cobros y pagos conforme a la normativa vigente.
    </li>
    <li>
      Nos reservamos el derecho de transferir a un tercero cualquier información de la que dispongamos sobre los Usuarios en caso de que se
      produzca cualquier transferencia o venta real o potencial de la totalidad o parte de nuestro negocio o activos (incluidos los
      supuestos de fusión, adquisición, joint venture, reestructuración, cesión, disolución o liquidación) u otra operación estructural o
      mercantil. En tal caso, se requerirá a dichos terceros que garanticen niveles de protección comparables a aquéllos que proporciona
      Grupo ACCIONA respecto a la información que va a ser compartida.
    </li>
    <li>
      Podremos intercambiar información personal con proveedores de servicios sean empresas de ACCIONA o terceras, en algunos supuestos
      contratados para realizar servicios en nuestro nombre. En estos casos, siempre que sea necesario, se suscriben los correspondientes
      contratos de encargo de tratamiento según establece la normativa en materia de protección de datos.
    </li>
    <li>
      Igualmente informamos que algunos de los prestadores de servicios o terceras pueden estar ubicados en territorios situados fuera del
      Espacio Económico Europeo que no proporcionen un nivel de protección de datos equiparable al de la Unión Europea. En tales casos las
      transferencias están amparadas en alguno de los mecanismos de garantía que establece la legislación vigente en materia de protección
      de datos, como contar con un mecanismo de adecuación legal reconocido, incluyendo la formalización de Cláusulas Contractuales Tipo
      aprobadas por la Comisión, cuyo contenido se puede consultar en el siguiente enlace:
      <a [href]="_thirdPartyEuClausesWeb" target="_blank" rel="noreferrer noopener"> {{ _thirdPartyEuClausesWeb }}</a
      >.
    </li>
  </ul>
  <h5 class="mb-2"><strong>¿Cuáles son los derechos del Usuario cuando tratamos sus datos?</strong></h5>
  <p class="mb-2">
    El Usuario puede ejercitar sus derechos de acceso, rectificación, supresión, portabilidad de sus datos, y/o la limitación u oposición a
    su tratamiento, ante el responsable del tratamiento correspondiente, o, dirigiéndose por escrito al Departamento de Protección de Datos
    personales, en Avenida de la Gran Vía de Hortaleza, 1, 28033, Madrid, o mediante el envío del formulario disponible en el siguiente
    enlace,
    <a
      href="https://www.acciona-energia.com/es/politica-privacidad/?activeForm=true&_adin=11551547647"
      target="_blank"
      rel="noreferrer noopener"
    >
      FORMULARIO</a
    >. En caso de que consideremos necesario para poder identificarle, podremos solicitarte copia de un documento acreditativo de su
    identidad.
  </p>
  <p class="mb-2">
    Asimismo, podrá en cualquier momento, retirar el consentimiento prestado dirigiéndose a la dirección arriba indicada, así como a
    presentar una reclamación ante la Autoridad de Control en materia de protección de datos pertinente
    <a target="_blank" rel="noreferrer noopener" href="https://www.agpd.es/portalwebAGPD/index-ides-idphp.ph"
      >(https://www.agpd.es/portalwebAGPD/index-ides-idphp.ph)</a
    >
    y, en particular, ante la Agencia Española de Protección de Datos (<a
      href="https://www.aepd.es"
      target="_blank"
      rel="noreferrer noopener"
      >www.aepd.es</a
    >).
  </p>
  <h5 class="mb-1"><strong>Información ampliada</strong></h5>
  <p class="mb-2">
    A continuación, ponemos a su disposición una serie de enlaces en los que se podrá obtener información ampliada que podría resultarle
    útil en relación con otros tratamientos de datos personales,
  </p>
  <h5 class="mb-1"><strong>Grupo ACCIONA Energía</strong></h5>
  <p class="mb-2">
    Puede obtener información ampliada sobre el tratamiento de datos personales por parte de entidades del Grupo Acciona en
    <a target="_blank" rel="noreferrer noopener" href="https://www.acciona-energia.com/es/?_adin=02021864894"
      >https://www.acciona-energia.com/es/?_adin=02021864894</a
    >
  </p>
  <h5 class="mb-1"><strong>Vigencia</strong></h5>
  <p class="mb-2">
    Cualquier cambio realizado en la Política de Privacidad y en las prácticas de administración de la información se reflejará de forma
    oportuna, pudiendo el Responsable, agregar, modificar o eliminar dicha Política de Privacidad cuando lo estime necesario.
  </p>
  <p class="mb-2">Última actualización, 1 de febrero de 2024</p>
  <h5 class="mb-1">
    <strong>Servicio de Atención al Cliente</strong>
  </h5>
  <p class="mb-2">
    Email:<a href="mailto:{{ _helpEmailSig() }}" target="_blank" rel="noreferrer noopener"> {{ _helpEmailSig() }}</a> /
    <a href="tel:+34{{ _phoneNumber }}">{{ _phoneNumber }}</a>
  </p>
</ng-template>
<ng-template #englishPolicy>
  <h4 class="mb-2">PRIVACY POLICY FOR SERVICES IN SPAIN</h4>
  <p class="mb-2">
    ACCIONA GREEN ENERGY DEVELOPMENTS, S.L. (hereinafter, ACCIONA GREEN ENERGY), in accordance with Regulation (EU) 2016/679, April 27,
    2016, relating to the protection of natural persons with regard to the processing of personal data and the free circulation of these,
    and other current regulations regarding Data Protection; makes available to all those who, through their interaction with us, provide
    personal information (hereinafter, “User”), through this website (hereinafter, the “Page”), the Privacy Policy that will apply in the
    processing of personal data.
  </p>
  <p class="mb-2">
    Personal data may only be obtained for processing when they are adequate, relevant and not excessive in relation to with the scope and
    determined, explicit and legitimate purposes for which they were obtained. The User expressly consents that ACCIONA GREEN ENERGY can
    process the personal data provided by it for the purposes expressed in the this Privacy Policy.
  </p>
  <p class="mb-2">
    ACCIONA GREEN ENERGY adopts the necessary technical and organizational measures to guarantee the security of the company's data.
    personal nature contained therein and to avoid its alteration, loss, treatment or unauthorized access, taking into account the state of
    the technology, the nature of the data and the risks to which they are exposed.
  </p>
  <p class="mb-2">
    You can also verify the presence of the SSL certificate by checking the Page properties in your browser. A connection will be secure
    when "https://" appears in the browser's address bar instead of "http://" and a padlock symbol is displayed. You can consult more
    characteristics of the SSL certificate in the Legal Notice section.
  </p>
  <h5 class="mb-2"><strong>Who is responsible for the processing of personal data?</strong></h5>
  <ul>
    <li><strong>Company name:</strong> ACCIONA GREEN ENERGY DEVELOPMENTS, S.L.</li>
    <li><strong>CIF: </strong>B-31737422.</li>
    <li><strong>Address:</strong> Avenida de la Gran Vía de Hortaleza, 1, 28033, Madrid.</li>
    <li>
      <strong>Phone:</strong> <a href="tel:+34{{ _phoneNumber }}"> {{ _phoneNumber }}</a>
    </li>
  </ul>
  <p class="mb-2">
    The Data Protection Officer is a point of contact with the responsible entity for issues related to data processing. personal. If you
    wish, you can contact him at:
    <strong
      ><a href="mailto:{{ _protectDataContactEmail }}" target="_blank" rel="noreferrer noopener">{{ _protectDataContactEmail }}</a></strong
    >
  </p>
  <h5 class="mb-2"><strong>What data can we collect through the Page?</strong></h5>
  <p class="mb-2">Personal data is considered to be data that identifies a person or can be used to identify them.</p>
  <p class="mb-2">
    We may receive the personal data provided directly by the User, through their visit to the Page and when they register in our service
    or, when the User contacts the User Service Center (CAU) or Customer Service (SAC), either either by email or by phone (calls are
    recorded and you are warned of this in advance, so that you do not continue if does not want to be recorded).
  </p>
  <p class="mb-2">
    Also, as a consequence of your interaction with us, we may receive your personal data when you complete forms or surveys, when you
    request information from us, send requests, communicate incidents, etc. In other cases, personal data is obtained <u>indirectly</u> from
    the user in order to analyze their use of our Page (See our <a [routerLink]="_cookiesRoute">Cookie Policy</a> or provide you with other
    value-added services.
  </p>
  <h5 class="mb-2"><strong>Among the categories of data that we can process are:</strong></h5>
  <ul class="space-y-2 mb-2 ml-5">
    <li>
      Identification and contact data: name and surname, ID or valid identification document, address, country of residence, number phone,
      email, IP address.
    </li>
    <li>Financial data or data related to the service provided: billing data.</li>
  </ul>
  <p class="mb-2">
    The User is solely responsible for the veracity and legality of the personal data provided, and assumes the obligation to communicate
    any change in them to ACCIONA when those it has become inaccurate or incorrect.
  </p>

  <h5 class="mb-2"><strong>For what purpose and legitimacy do we process the User's personal data?</strong></h5>
  <p class="mb-2">ACCIONA GREEN ENERGY collects and processes the personal data of Users, for the following purposes:</p>

  <ul class="space-y-2 mb-2 ml-5">
    <li>
      <strong>Manage the relationship established with us</strong>
      <p class="mb-2">
        Manage the energy supply contract, manage billing, provide you with access to all related documents of your contract. <br />
        Answer your questions and requests through the available questionnaires. <br />
        Processing claims, complaints and suggestions. <br />
        In these cases, the legal basis of the treatment is the consent given by the User, as well as the execution of a contract. and/or
        the legal relationships established with ACCIONA GREEN ENERGY.
      </p>
    </li>
    <li>
      <strong>Service management with the User</strong>
      <p class="mb-2">
        Manage registration as a registered User, and account maintenance. Administration and management of User accounts service. Respond
        to and process requests for information, claims, complaints, suggestions, incidents and/or queries received through through the User
        Service Center or the User Service. <br />
        In these cases, the legal basis of the treatment is the consent given by the User, as well as the execution of a contract. and/or
        the established legal relationships.
      </p>
    </li>
    <li>
      <strong>Compliance with the legal obligations that affect us.</strong>
      <p class="mb-2">
        Whether these legal obligations are of a commercial, fiscal, accounting, or administrative nature. This purpose of the treatment may
        entail the transfer of data to public organizations and authorities, as long as they are required in accordance with the legal and
        regulatory provisions. <br />
        In these cases, the legal basis of the treatment is the fulfillment of legal obligations of the person responsible.
      </p>
    </li>
    <li>
      <strong>Fraud prevention</strong>
      <p class="mb-2">
        Sometimes it is necessary to verify identity in order to offer protection, detect and prevent fraud or other illegal activities,
        unauthorized transactions, claims and other types of responsibilities, as well as managing the quality and the risks associated with
        the business; as well as investigate, if necessary, illegal activities and potential breaches of our policies and/or conditions of
        our services. <br />
        The legal basis is the fulfillment of legal obligations that apply in each case.
      </p>
    </li>
    <li>
      <strong>Statistics and satisfaction surveys</strong>
      <p class="mb-2">
        We may process User data to carry out satisfaction surveys in relation to our services, as well as collect cookies by browsing web
        environments. The legitimizing basis in this case is the consent given by the User.
      </p>
    </li>
    <li>
      <strong>Promotional activities and commercial communications</strong>
      <ul class="space-y-2 mb-2 ml-5">
        <li>
          Offer you, among others, access to advertisements and notices where you will find relevant information and news about the market
          electric.
        </li>
        <li>
          Information on the management of the sale of energy produced by the group's facilities, as well as that of others producers, at
          whose service it puts its experience and technical capacity with a guarantee of 100% renewable origin.
        </li>
        <li>
          Sending commercial communications, as well as invitations to events and activities, by postal and electronic means, related to the
          services and products contracted with ACCIONA GREEN ENERGY.
        </li>
      </ul>
    </li>
    <p class="mb-2">
      In these cases, the legal basis of the treatment is the consent given by the User, as well as the execution of a contract. and/or the
      established legal relationships.
    </p>

    <li>
      <strong>Checking the solvency of Users to sign a contract</strong>
      <p class="mb-2">
        When a User wants to formalize an electricity supply contract, ACCIONA turns to third-party companies to find out the financial
        solvency of the User and, where appropriate, request additional guarantees, as explained in the contract. Thus, ACCIONA will collect
        personal data of the User from third parties whose corporate purpose is to provide references or commercial reports and of financial
        or credit solvency, provided that they express their willingness to formalize a contract with ACCIONA. With such Personal solvency
        data of the User, in addition to the rest of the information provided, ACCIONA may assess the viability of the contract. The
        information obtained from said third parties will be maintained by ACCIONA for as long as the data is stored. contained in the
        Contract (a period that may be up to six years from its termination), or (b) for one (1) month from the the contracting process ends
        up not being viable, to address possible claims from those people with whom it is not a contract could have been concluded. Such
        information obtained from third parties, together with the rest of the information provided by the CUSTOMER, is necessary for the
        correct execution of the contract (since the solvency of both parties is essential) and is collected by ACCIONA not only based on
        the need for the Contract to be fulfilled, but also based on its legitimate interest as a company that It supplies electrical energy
        in exchange for a price.
      </p>
    </li>
  </ul>

  <h5 class="mb-2"><strong>How long does ACCIONA GREEN ENERGY retain the User's personal data?</strong></h5>
  <p class="mb-2">
    In general, the data will be kept i) for the time necessary for the purpose for which it was collected and, ii) during the applicable
    prescription periods, if responsibilities arising from the treatment may arise, or for comply with obligations required of ACCIONA that
    require it to retain such data (such as, for example, the obligations to conserve the information established in the Commercial Code).
  </p>
  <p class="mb-2">On a particular basis,</p>
  <ul class="space-y-2 mb-2 ml-5">
    <li>
      The data collected for the purpose of responding to requests or queries will be kept for the time necessary to be able to attend to
      them.
    </li>
    <li>The data collected based on your consent will be kept as long as it is not withdrawn.</li>
    The data collected from third parties to evaluate solvency will be kept (a) for the entire life of the contract signed with the User, or
    (b) for one month from the start of an unsuccessful contracting process, to address any claims of the person who has not been able to
    contract with ACCIONA.

    <p class="mb-2">
      The data will be kept as long as the relationship is maintained and its deletion is not requested and subsequently during the period
      of legal prescription of the actions that apply to them.
    </p>
  </ul>

  <h5 class="mb-2"><strong>To whom can the Controller provide the data provided by the User?</strong></h5>
  <p class="mb-2">Depending on the activity of ACCIONA GREEN ENERGY, the following data transfers are planned, when necessary:</p>
  <ul class="space-y-2 mb-2 ml-5">
    <li>
      To Public Administration Organizations with jurisdiction in matters of communications and provision of information services and
      Organizations with jurisdiction in consumer matters to address possible complaints from Users.
    </li>
    <li>
      To the Tax Agency and other competent state, regional and local administrations and public entities, for the purposes of carry out the
      corresponding tax declarations (taxes and fees), as well as to financial, banking and credit, for the economic management of
      commercial and financial operations and to payment gateways and/or insurance companies for the management of collections and payments
      in accordance with current regulations.
    </li>
    <li>
      We reserve the right to transfer any information we have about Users to a third party in the event that results in any actual or
      potential transfer or sale of all or part of our business or assets (including cases of merger, acquisition, joint venture,
      restructuring, assignment, dissolution or liquidation) or other structural or trade. In such case, said third parties will be required
      to guarantee levels of protection comparable to those provided ACCIONA Group regarding the information that will be shared.
    </li>
    <li>
      We may exchange personal information with service providers, whether ACCIONA companies or third parties, in some cases. contracted to
      perform services on our behalf. In these cases, whenever necessary, the corresponding processing commission contracts as established
      by data protection regulations.
    </li>
    <li>
      We also inform you that some of the service providers or third parties may be located in territories outside the European Economic
      Area that do not provide a level of data protection comparable to that of the European Union. In such cases the Transfers are covered
      by one of the guarantee mechanisms established by current legislation on protection. of data, such as having a recognized legal
      adaptation mechanism, including the formalization of Standard Contractual Clauses approved by the Commission, the content of which can
      be consulted at the following link:
      <a [href]="_thirdPartyEuClausesWeb" target="_blank" rel="noreferrer noopener"> {{ _thirdPartyEuClausesWeb }}</a
      >.
    </li>
  </ul>
  <h5 class="mb-2"><strong>What are the User's rights when we process their data?</strong></h5>
  <p class="mb-2">
    The User may exercise their rights of access, rectification, deletion, portability of their data, and/or limitation or opposition to the
    processing of it, before the corresponding data controller, or, by writing to the Data Protection Department personal, at Avenida de la
    Gran Vía de Hortaleza, 1, 28033, Madrid, or by sending the form available at the following link,
    <a href="https://www.acciona-energia.com/privacy-policy/?_adin=11551547647#" target="_blank" rel="noreferrer noopener">FORM</a>. If we
    consider it necessary to identify you, we may request a copy of a document. proof of his identity.
  </p>
  <p class="mb-2">
    Likewise, you may, at any time, withdraw the consent given by contacting the address indicated above, as well as to file a claim with
    the relevant data protection Supervisory Authority
    <a target="_blank" rel="noreferrer noopener" href="https://www.agpd.es/portalwebAGPD/index-ides-idphp.ph"
      >(https://www.agpd.es/portalwebAGPD/index-ides-idphp.ph)</a
    >
    and, in particular, before the Spanish Data Protection Agency (<a href="https://www.aepd.es" target="_blank" rel="noreferrer noopener"
      >www.aepd.es</a
    >).
  </p>
  <h5 class="mb-1"><strong>Extended information</strong></h5>
  <p class="mb-2">
    Below, we put at your disposal a series of links where you can obtain additional information that could be useful to you. useful in
    relation to other processing of personal data,
  </p>
  <h5 class="mb-1"><strong>ACCIONA Energy Group</strong></h5>
  <p class="mb-2">
    You can obtain expanded information on the processing of personal data by Acciona Group entities at
    <a target="_blank" rel="noreferrer noopener" href="https://www.acciona-energia.com/es/?_adin=02021864894"
      >https://www.acciona-energia.com/es/?_adin=02021864894</a
    >
  </p>
  <h5 class="mb-1"><strong>Validity</strong></h5>
  <p class="mb-2">
    Any changes made to the Privacy Policy and information management practices will be reflected timely, and the Controller may add, modify
    or delete said Privacy Policy when it deems necessary.
  </p>
  <p class="mb-2">Last updated, February 1, 2024</p>
  <h5 class="mb-1">
    <strong>Customer Service</strong>
  </h5>
  <p class="mb-2">
    Email:<a href="mailto:{{ _helpEmailSig() }}" target="_blank" rel="noreferrer noopener"> {{ _helpEmailSig() }}</a> /
    <a href="tel:+34{{ _phoneNumber }}">{{ _phoneNumber }}</a>
  </p>
</ng-template>
<ng-template #portuguesePolicy>
  <h4 class="mb-2">POLÍTICA DE PRIVACIDADE PARA SERVIÇOS EM ESPANHA</h4>
  <p class="mb-2">
    ACCIONA GREEN ENERGY DEVELOPMENTS, S.L. (doravante, ACCIONA GREEN ENERGY), de acordo com o Regulamento (UE) 2016/679, de 27 de abril de
    2016, relativas à protecção das pessoas singulares no que diz respeito ao tratamento de dados pessoais e à livre circulação de estas e
    outras regulamentações vigentes em matéria de Proteção de Dados; coloca à disposição de todos aqueles que, através da sua interação com
    nós, fornecer informações pessoais (doravante, “Usuário”), através deste site (doravante, a “Página”), a Política de Privacidade que
    será aplicada no tratamento de dados pessoais.
  </p>
  <p class="mb-2">
    Os dados pessoais só poderão ser obtidos para tratamento quando forem adequados, relevantes e não excessivos em relação aos com o
    alcance e os fins determinados, explícitos e legítimos para os quais foram obtidos. O Usuário consente expressamente que a ACCIONA GREEN
    ENERGY possa tratar os dados pessoais por ela fornecidos para os fins expressos no esta Política de Privacidade.
  </p>
  <p class="mb-2">
    A ACCIONA GREEN ENERGY adota as medidas técnicas e organizacionais necessárias para garantir a segurança dos dados da empresa. caráter
    pessoal nele contido e evitar a sua alteração, perda, tratamento ou acesso não autorizado, tendo em conta a estado da tecnologia, a
    natureza dos dados e os riscos a que estão expostos.
  </p>
  <p class="mb-2">
    Você também pode verificar a presença do certificado SSL verificando as propriedades da página no seu navegador. Uma conexão será seguro
    quando "https://" aparece na barra de endereço do navegador em vez de "http://" e um símbolo de cadeado é exibido. Poderá consultar mais
    características do certificado SSL na secção Aviso Legal.
  </p>
  <h5 class="mb-2"><strong>Quem é responsável pelo processamento de dados pessoais?</strong></h5>
  <ul>
    <li><strong>Nome da empresa:</strong> ACCIONA GREEN ENERGY DEVELOPMENTS, S.L.</li>
    <li><strong>CIF: </strong>B-31737422.</li>
    <li><strong>Endereço:</strong> Avenida de la Gran Vía de Hortaleza, 1, 28033, Madrid.</li>
    <li>
      <strong>Telefone:</strong> <a href="tel:+34{{ _phoneNumber }}"> {{ _phoneNumber }}</a>
    </li>
  </ul>
  <p class="mb-2">
    O Encarregado da Proteção de Dados é o ponto de contacto com a entidade responsável pelas questões relacionadas com o tratamento de
    dados. pessoal. Se desejar, você pode contatá-lo em:
    <strong
      ><a href="mailto:{{ _protectDataContactEmail }}" target="_blank" rel="noreferrer noopener">{{ _protectDataContactEmail }}</a></strong
    >
  </p>
  <h5 class="mb-2"><strong>Quais dados podemos coletar por meio da Página?</strong></h5>
  <p class="mb-2">Dados pessoais são considerados dados que identificam uma pessoa ou podem ser usados para identificá-la.</p>
  <p class="mb-2">
    Poderemos receber os dados pessoais fornecidos diretamente pelo Utilizador, através da sua visita à Página e quando se regista na nosso
    serviço ou, quando o Usuário entrar em contato com o Centro de Atendimento ao Usuário (CAU) ou Serviço de Atendimento ao Consumidor
    (SAC), ou seja por e-mail ou por telefone (as ligações são gravadas e você é avisado com antecedência, para que não continue se não quer
    ser gravado).
  </p>
  <p class="mb-2">
    Além disso, como consequência da sua interação connosco, poderemos receber os seus dados pessoais quando preencher formulários ou
    inquéritos, quando você nos solicita informações, envia solicitações, comunica incidentes, etc. Noutros casos, os dados pessoais são
    obtidos indiretamente do usuário para analisar o uso que ele faz de nossa Página (Veja nosso
    <a [routerLink]="_cookiesRoute">Política de Cookies</a> ou fornecer outros serviços de valor agregado.
  </p>

  <h5 class="mb-2"><strong>Entre as categorias de dados que podemos processar estão:</strong></h5>
  <ul class="espaço-y-2 mb-2 ml-5">
    <li>
      Dados de identificação e contacto: nome e apelido, BI ou documento de identificação válido, morada, país de residência, número
      telefone, e-mail, endereço IP.
    </li>
    <li>Dados financeiros ou relacionados ao serviço prestado: dados de cobrança.</li>
  </ul>
  <p class="mb-2">
    O Utilizador é o único responsável pela veracidade e legalidade dos dados pessoais fornecidos, e assume a obrigação de comunicar
    qualquer alteração dos mesmos à ACCIONA quando estes se tornem imprecisos ou incorretos.
  </p>
  <h5 class="mb-2"><strong>Com que finalidade e legitimidade tratamos os dados pessoais do Usuário?</strong></h5>
  <p class="mb-2">A ACCIONA GREEN ENERGY recolhe e trata os dados pessoais dos Utilizadores, para as seguintes finalidades:</p>

  <ul class="espaço-y-2 mb-2 ml-5">
    <li>
      <strong>Gerir a relação que estabelece connosco</strong>
      <p class="mb-2">
        Gerir o contrato de fornecimento de energia, gerir a faturação, dar-lhe acesso a todos os documentos relacionados do seu contrato.
        <br />
        Responda às suas dúvidas e solicitações através dos questionários disponíveis. <br />
        Processamento de reclamações, reclamações e sugestões. <br />
        Nestes casos, a base legal do tratamento é o consentimento dado pelo Utilizador, bem como a execução de um contrato. e/ou as
        relações jurídicas estabelecidas com a ACCIONA GREEN ENERGY.
      </p>
    </li>
    <li>
      <strong>Gerenciamento de serviços com o Usuário</strong>
      <p class="mb-2">
        Gerenciar o registro como usuário registrado e a manutenção da conta. Administração e gerenciamento de contas de usuários serviço.
        Responder e processar solicitações de informações, reclamações, reclamações, sugestões, incidentes e/ou dúvidas recebidas através de
        através do Centro de Atendimento ao Usuário ou do Atendimento ao Usuário. <br />
        Nestes casos, a base legal do tratamento é o consentimento dado pelo Utilizador, bem como a execução de um contrato. e/ou as
        relações jurídicas estabelecidas.
      </p>
    </li>
    <li>
      <strong>Cumprimento das obrigações legais que nos afetam.</strong>
      <p class="mb-2">
        Se essas obrigações legais são de natureza comercial, fiscal, contábil ou administrativa. Este objetivo do tratamento pode
        implicarão a transferência de dados para organizações e autoridades públicas, desde que sejam exigidas de acordo com o disposições
        legais e regulamentares. <br />
        Nestes casos, a base legal do tratamento é o cumprimento das obrigações legais do responsável.
      </p>
    </li>
    <li>
      <strong>Prevenção de fraude</strong>
      <p class="mb-2">
        Às vezes é necessário verificar a identidade para oferecer proteção, detectar e prevenir fraudes ou outros atividades ilegais,
        transações não autorizadas, reclamações e outros tipos de responsabilidades, bem como gerenciar a qualidade e os riscos associados
        ao negócio; bem como investigar, se necessário, atividades ilegais e possíveis violações das nossas políticas e/ou condições dos
        nossos serviços. <br />
        A base legal é o cumprimento das obrigações legais aplicáveis em cada caso.
      </p>
    </li>
    <li>
      <strong>Estatísticas e pesquisas de satisfação</strong>
      <p class="mb-2">
        Poderemos tratar os dados dos Usuários para realizar pesquisas de satisfação em relação aos nossos serviços, bem como coletar
        cookies navegando em ambientes web. A base legitimadora neste caso é o consentimento dado pelo Do utilizador.
      </p>
    </li>
    <li>
      <strong>Atividades promocionais e comunicações comerciais</strong>
      <ul class="espaço-y-2 mb-2 ml-5">
        <li>
          Oferecer-lhe, entre outros, acesso a anúncios e avisos onde encontrará informações e novidades relevantes sobre o mercado
          elétrico.
        </li>
        <li>
          Informação sobre a gestão da venda de energia produzida nas instalações do grupo, bem como de terceiros produtores, a cujo serviço
          coloca a sua experiência e capacidade técnica com garantia de origem 100% renovável.
        </li>
        <li>
          Envio de comunicações comerciais, bem como convites para eventos e atividades, por meios postais e eletrónicos, relacionados aos
          serviços e produtos contratados com a ACCIONA GREEN ENERGY.
        </li>
      </ul>
    </li>
    <p class="mb-2">
      Nestes casos, a base legal do tratamento é o consentimento dado pelo Utilizador, bem como a execução de um contrato. e/ou as relações
      jurídicas estabelecidas.
    </p>
    <li>
      <strong>Verificar a solvência dos Usuários para assinar um contrato</strong>
      <p class="mb-2">
        Quando um Usuário deseja formalizar um contrato de fornecimento de energia elétrica, a ACCIONA recorre a empresas terceirizadas para
        saber a solvência financeira do Utilizador e, se for caso disso, solicitar garantias adicionais, conforme explicado no contrato.
        Assim, ACCIONA coletará dados pessoais do Usuário de terceiros cujo objeto social seja fornecer referências ou relatórios comerciais
        e de solvabilidade financeira ou creditícia, desde que manifestem a sua vontade de formalizar um contrato com a ACCIONA. Com tamanha
        Dados de solvência pessoal do Usuário, além do restante da informação fornecida, a ACCIONA poderá avaliar a viabilidade do contrato.
        As informações obtidas de tais terceiros serão mantidas pela ACCIONA enquanto os dados forem armazenados. contido no Contrato
        (período que pode ser de até seis anos a partir de sua rescisão), ou (b) por 1 (um) mês a partir da o processo de contratação acaba
        não sendo viável, para atender possíveis reclamações daquelas pessoas com quem não é um contrato poderia ter sido celebrado. Essas
        informações obtidas de terceiros, juntamente com o restante das informações fornecidas pelo CLIENTE, é necessária à correta execução
        do contrato (uma vez que a solvência de ambas as partes é essencial) e é cobrada pelo A ACCIONA não só com base na necessidade de
        cumprimento do Contrato, mas também com base no seu legítimo interesse como empresa que Fornece energia elétrica em troca de um
        preço.
      </p>
    </li>
  </ul>

  <h5 class="mb-2"><strong>Por quanto tempo a ACCIONA GREEN ENERGY retém os dados pessoais do Usuário?</strong></h5>
  <p class="mb-2">
    Em geral, os dados serão conservados i) pelo tempo necessário à finalidade para a qual foram recolhidos e, ii) durante os prazos de
    prescrição aplicáveis, se surgirem responsabilidades decorrentes do tratamento, ou por cumprir as obrigações exigidas à ACCIONA que a
    obrigam a conservar tais dados (como, por exemplo, as obrigações de conservar a informação estabelecida no Código Comercial).
  </p>
  <p class="mb-2">Em uma base específica,</p>
  <ul class="espaço-y-2 mb-2 ml-5">
    <li>
      Os dados recolhidos para efeitos de resposta a pedidos ou dúvidas serão conservados pelo tempo necessário para podermos atende-los.
    </li>
    <li>Os dados coletados com base no seu consentimento serão mantidos enquanto não forem retirados.</li>
    Os dados recolhidos de terceiros para avaliação de solvência serão conservados (a) durante toda a vigência do contrato celebrado com o
    Usuário, ou (b) por um mês a partir do início de um processo de contratação mal sucedido, para resolver quaisquer reclamações de a
    pessoa que não conseguiu contratar com a ACCIONA.

    <p class="mb-2">
      Os dados serão conservados enquanto a relação se mantiver e não for solicitada a sua eliminação e posteriormente durante o período de
      prescrição legal das ações que lhes são aplicáveis.
    </p>
  </ul>

  <h5 class="mb-2"><strong>A quem o Controlador pode fornecer os dados fornecidos pelo Usuário?</strong></h5>
  <p class="mb-2">
    Dependendo da atividade da ACCIONA GREEN ENERGY, estão previstas as seguintes transferências de dados, quando necessário:
  </p>
  <ul class="espaço-y-2 mb-2 ml-5">
    <li>
      Aos Organismos da Administração Pública com competência em matéria de comunicações e prestação de serviços de informação e
      Organizações com jurisdição em matéria de consumo para responder a possíveis reclamações dos Utilizadores.
    </li>
    <li>
      À Agência Tributária e demais administrações estaduais, regionais e locais e entidades públicas competentes, para efeitos de realizar
      as correspondentes declarações fiscais (impostos e taxas), bem como aos serviços financeiros, bancários e crédito, para a gestão
      económica de operações comerciais e financeiras e a plataformas de pagamento e/ou seguradoras para a gestão de cobranças e pagamentos
      de acordo com a regulamentação vigente.
    </li>
    <li>
      Reservamo-nos o direito de transferir qualquer informação que tenhamos sobre os Usuários a terceiros no caso de resulte em qualquer
      transferência ou venda real ou potencial de todo ou parte de nossos negócios ou ativos (incluindo casos de fusão, aquisição, joint
      venture, reestruturação, cessão, dissolução ou liquidação) ou outros problemas estruturais ou troca. Nesse caso, esses terceiros serão
      obrigados a garantir níveis de proteção comparáveis aos fornecidos Grupo ACCIONA sobre as informações que serão compartilhadas.
    </li>
    <li>
      Poderemos trocar informações pessoais com prestadores de serviços, sejam empresas ACCIONA ou terceiros, em alguns casos. contratado
      para executar serviços em nosso nome. Nestes casos, sempre que necessário, os correspondentes processar contratos de comissão conforme
      estabelecido pelos regulamentos de proteção de dados.
    </li>
    <li>
      Informamos também que alguns dos prestadores de serviços ou terceiros podem estar localizados em territórios fora do Espaço Económico
      Europeu que não proporcionam um nível de protecção de dados comparável ao da União Europeia. Nesses casos o As transferências são
      cobertas por um dos mecanismos de garantia estabelecidos pela legislação vigente em matéria de proteção. de dados, como ter mecanismo
      de adaptação legal reconhecido, incluindo a formalização de Cláusulas Contratuais Padrão aprovado pela Comissão, cujo conteúdo pode
      ser consultado no seguinte link:
      <a [href]="_thirdPartyEuClausesWeb" target="_blank" rel="noreferrer noopener"> {{ _thirdPartyEuClausesWeb }}</a
      >.
    </li>
  </ul>
  <h5 class="mb-2"><strong>Quais são os direitos do Usuário quando processamos seus dados?</strong></h5>
  <p class="mb-2">
    O Utilizador poderá exercer os seus direitos de acesso, retificação, eliminação, portabilidade dos seus dados e/ou limitação ou oposição
    aos mesmos. seu tratamento, ao responsável pelo correspondente tratamento, ou, por escrito ao Departamento de Proteção de Dados
    pessoalmente, na Avenida de la Gran Vía de Hortaleza, 1, 28033, Madrid, ou enviando o formulário disponível no seguinte endereço link,
    <a href="https://www.acciona.com.br/politica-privacidad/?activeForm=true&_adin=02021864894" target="_blank" rel="noreferrer noopener"
      >FORMULÁRIO</a
    >. Se considerarmos necessário identificá-lo, poderemos solicitar uma cópia de um documento. prova de sua identidade.
  </p>
  <p class="mb-2">
    Da mesma forma, poderá, a qualquer momento, retirar o consentimento prestado contactando o endereço acima indicado, bem como registrar
    uma reclamação junto à Autoridade Supervisora de proteção de dados relevante
    <a target="_blank" rel="noreferrer noopener" href="https://www.agpd.es/portalwebAGPD/index-ides-idphp.ph"
      >(https://www.agpd.es/portalwebAGPD/index-ides-idphp.ph)</a
    >
    e, em particular, perante a Agência Espanhola de Proteção de Dados (<a
      href="https://www.aepd.es"
      target="_blank"
      rel="noreferrer noopener"
      >www.aepd.es</a
    >).
  </p>
  <h5 class="mb-1"><strong>Informações estendidas</strong></h5>
  <p class="mb-2">
    A seguir colocamos à sua disposição uma série de links onde poderá obter informações adicionais que poderão ser úteis para você. útil em
    relação a outro processamento de dados pessoais,
  </p>
  <h5 class="mb-1"><strong>Grupo ACCIONA Energia</strong></h5>
  <p class="mb-2">
    Você pode obter informações ampliadas sobre o tratamento de dados pessoais pelas entidades do Grupo Acciona em
    <a target="_blank" rel="noreferrer noopener" href="https://www.acciona-energia.com/es/?_adin=02021864894"
      >https://www.acciona-energia.com/es/?_adin=02021864894</a
    >
  </p>
  <h5 class="mb-1"><strong>Validade</strong></h5>
  <p class="mb-2">
    Quaisquer alterações feitas na Política de Privacidade e nas práticas de gestão de informações serão refletidas oportunamente, e o
    Controlador poderá adicionar, modificar ou excluir a referida Política de Privacidade quando julgar necessário.
  </p>
  <p class="mb-2">Última atualização, 1º de fevereiro de 2024</p>
  <h5 class="mb-1">
    <strong>Atendimento ao Cliente</strong>
  </h5>
  <p class="mb-2">
    E-mail:<a href="mailto:{{ _helpEmailSig() }}" target="_blank" rel="noreferrer noopener"> {{ _helpEmailSig() }}</a> /
    <a href="tel:+34{{ _phoneNumber }}">{{ _phoneNumber }}</a>
  </p>
</ng-template>
